<template>
  <div>
    <h3 class="d-flex justify-space-between align-center">
      <v-btn
        icon
        color="grey"
        @click="toBack"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span>ユーザ情報の登録</span>
      <span style="min-width: 36px" />
    </h3>

    <validation-observer ref="InvitationUserFormValidator">
      <v-form>
        <v-card flat class="rounded-card">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <v-card outlined>
                  <v-card-text style="margin: 0 auto">
                    <v-img
                      :src="user.image_url | load_image_url"
                      max-height="160"
                      contain
                      aspect-ratio="1"
                      class="gray lighten-4 align-center"
                    />
                  </v-card-text>
                  <v-divider />
                  <v-card-text style="margin: 0 auto">
                    <validation-provider
                      v-slot="{ errors }"
                      rules="mimes:image/jpeg,image/png"
                      name="プロフィール画像"
                    >
                      <v-row
                        class="text-center"
                        @dragover.prevent
                        @dragenter="onDragEnter"
                        @dragleave="onDragLeave"
                        @drop="onDrop"
                      >
                        <v-col>
                          <v-file-input
                            v-model="user.avatar"
                            :background-color="isDragging ? 'blue' : 'null'"
                            :clearable="false"
                            :show-size="1000"
                            :error-messages="errors"
                            :prepend-icon="null"
                            accept="image/jpeg,image/png"
                            append-icon="mdi-folder"
                            dense
                            hide-details="auto"
                            hint="画像ファイルを選択して下さい"
                            persistent-hint
                            outlined
                            persistent-placeholder
                          >
                            <template v-slot:selection="{ index, text }">
                              <v-chip
                                v-if="index < 2"
                                color="deep-purple accent-4"
                                dark
                                label
                                small
                              >
                                {{ text }}
                              </v-chip>
                              <span
                                v-else-if="index === 2"
                                class="overline grey--text text--darken-3 mx-2"
                              >+{{ files.length - 2 }} File(s)</span>
                            </template>
                          </v-file-input>
                        </v-col>
                      </v-row>
                    </validation-provider>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="8">
                <!-- 氏名／フリガナ -->
                <v-row>
                  <v-col cols="12" md="6">
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required|full_width|max:12"
                      class="requiredMark"
                      name="氏名"
                    >
                      <v-text-field
                        v-model="user.name"
                        :error-messages="errors"
                        dense
                        label="氏名"
                        hide-details="auto"
                        outlined
                        persistent-placeholder
                        placeholder="例）テスト　太郎"
                        required
                      >
                        <template v-slot:label>
                          <span>氏名</span>
                          <span class="ml-1">
                            ({{ user.name?.length || 0 }} / 12)
                          </span>
                        </template>
                        <template v-slot:counter></template>
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <validation-provider
                      v-slot="{ errors }"
                      rules="katakana_only|max:20"
                      name="フリガナ"
                    >
                      <v-text-field
                        v-model="user.name_furigana"
                        :error-messages="errors"
                        dense
                        hide-details="auto"
                        label="フリガナ"
                        outlined
                        persistent-placeholder
                        placeholder="例）テストタロウ"
                      >
                        <template v-slot:label>
                          <span>フリガナ</span>
                          <span class="ml-1">
                            ({{ user.name_furigana?.length || 0 }} / 20)
                          </span>
                        </template>
                        <template v-slot:counter></template>
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <!-- /氏名／フリガナ -->

                <v-row>
                  <v-col cols="12" md="6">
                    <div class="fieldsetLabel">
                      <fieldset>
                        <legend>ロール</legend>
                        <span>{{ user.role | user_role }}</span>
                      </fieldset>
                      <v-divider />
                    </div>
                  </v-col>
                </v-row>

                <!-- メールアドレス -->
                <v-row>
                  <v-col cols="12" md="6">
                    <validation-provider
                      v-slot="{ errors }"
                      rules="email|max:255"
                      name="メールアドレス"
                    >
                      <v-text-field
                        v-model="user.email"
                        :error-messages="errors"
                        dense
                        autocomplete="off"
                        hide-details="auto"
                        label="メールアドレス"
                        outlined
                        persistent-placeholder
                        placeholder="例）test@dxe.jp"
                      >
                        <template v-slot:label>
                          <span>メールアドレス</span>
                          <span class="ml-1">
                            ({{ user.email?.length || 0 }} / 255)
                          </span>
                        </template>
                        <template v-slot:counter></template>
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <!-- メールアドレス-->

                <!-- 携帯番号 電話番号-->
                <v-row>
                  <v-col cols="12" md="6">
                    <validation-provider
                      v-slot="{ errors }"
                      :rules="{ numeric_hyphen_only: true, min: 2, max: 15 }"
                      name="携帯番号"
                    >
                      <v-text-field
                        v-model="user.mobile_number"
                        :error-messages="errors"
                        dense
                        autocomplete="off"
                        hide-details="auto"
                        label="携帯番号"
                        outlined
                        persistent-placeholder
                        hint="携帯番号をを「-」ハイフン「( )」込みで入力します"
                        persistent-hint
                        placeholder="例）000-0000-0000"
                      >
                        <template v-slot:label>
                          <span>携帯番号</span>
                          <span class="ml-1">
                            ({{ user.mobile_number?.length || 0 }} / 15)
                          </span>
                        </template>
                        <template v-slot:counter></template>
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <validation-provider
                      v-slot="{ errors }"
                      :rules="{ numeric_hyphen_only: true, min: 2, max: 15 }"
                      name="電話番号"
                    >
                      <v-text-field
                        v-model="user.phone_number"
                        :error-messages="errors"
                        autocomplete="off"
                        dense
                        hint="電話番号を「-」ハイフン「( )」込みで入力します"
                        hide-details="auto"
                        label="電話番号"
                        outlined
                        persistent-placeholder
                        persistent-hint
                        placeholder="例）000-0000-0000"
                      >
                        <template v-slot:label>
                          <span>電話番号</span>
                          <span class="ml-1">
                            ({{ user.phone_number?.length || 0 }} / 15)
                          </span>
                        </template>
                        <template v-slot:counter></template>
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <!-- /携帯番号 電話番号 -->
              </v-col>
            </v-row>

            <!-- 所属 役職 -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  rules="max:20"
                  name="所属"
                >
                  <v-text-field
                    v-model="user.affiliation"
                    :error-messages="errors"
                    dense
                    hide-details="auto"
                    label="所属"
                    outlined
                    persistent-placeholder
                    placeholder="例）管理部"
                  >
                    <template v-slot:label>
                      <span>所属</span>
                      <span class="ml-1">
                        ({{ user.affiliation?.length || 0 }} / 20)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  rules="max:20"
                  name="役職"
                >
                  <v-text-field
                    v-model="user.post"
                    :error-messages="errors"
                    dense
                    hide-details="auto"
                    label="役職"
                    outlined
                    persistent-placeholder
                    placeholder="例）部長"
                  >
                    <template v-slot:label>
                      <span>役職</span>
                      <span class="ml-1">
                        ({{ user.post?.length || 0 }} / 20)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /所属 役職 -->
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-col
              cols="12"
              class="text-center"
            >
              <v-btn
                color="primary"
                @click="toNext"
              >
                登録
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'InvitationUserForm',
  components: {},
  mixins: [],
  props: {
    user: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data () {
    return {
      showPassword: false,
      showConfirmPassword: false,
      isDragging: false,
      imageRemoved: false,
      dragCount: 0,
      files: [],
    }
  },
  watch: {
    'user.avatar' : function(newVal) {
      if (newVal) {
        this.getBase64(newVal).then((image) => {
          this.user.image_url = image
        })
      }

    }
  },
  created() {
  },
  methods: {
    ...mapActions('DriverActivate', {
      updateUser: 'update',
    }),
    toNext () {
      let $self = this
      this.$refs.InvitationUserFormValidator.validate().then((result) => {
        if (result) {
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation() {
      let params = this.buildForm()
      this.updateUser({ token: this.$route.params.token, params: params }).then(() => {
        this.$emit('toNextStep')
      })
    },
    toBack () {
      this.$emit('toBackStep')
    },
    buildForm () {
      const params = new FormData()
      params.append('login_id', this._nullToBlank(this.user.login_id))
      params.append('password', this._nullToBlank(this.user.password))
      params.append('password_confirmation', this._nullToBlank(this.user.password_confirmation))
      params.append('name', this._nullToBlank(this.user.name))
      params.append('name_furigana', this._nullToBlank(this.user.name_furigana))
      params.append('affiliation', this._nullToBlank(this.user.affiliation))
      params.append('post', this._nullToBlank(this.user.post))
      params.append('phone_number', this._nullToBlank(this.user.phone_number))
      params.append('mobile_number', this._nullToBlank(this.user.mobile_number))
      params.append('role', this._nullToBlank(this.user.role))
      params.append('email', this._nullToBlank(this.user.email))
      params.append('avatar', this._nullToBlank(this.user.avatar))
      return params
    },
    _nullToBlank(value) {
      return (value === null || value === undefined) ? '' : value
    },
    onDrop(e) {
      e.preventDefault();
      e.stopPropagation();
      this.isDragging = false;
      const _files = e.dataTransfer.files;
      this.user.avatar = _files[0];
    },
    onDragEnter(e) {
      e.preventDefault();
      this.isDragging = true;
      this.dragCount++;
    },

    onDragLeave(e) {
      e.preventDefault();
      this.dragCount--;
      if (this.dragCount <= 0) {
        this.isDragging = false;
      }
    },
    getBase64 (file) {
      /* Promiseにアロー関数を渡して非同期処理を書く。*/
      return new Promise((resolve, reject) => {

        /* 組み込みオブジェクトを使い、Base64エンコードされた画像データを取得  */
        const reader = new FileReader()
        reader.readAsDataURL(file)

        /* 成功時と失敗時の処理。resolveの引数に結果を渡して、のちの.then(result => ...)で受け取る  */
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },

  }
}
</script>
